///include /assets/js/app/p/payment-info-capture.js

class DirectDebitCaptureDriver extends PaymentInfoCaptureDriver {
    static get infoType() {
        return "directDebit"
    }
    static get type() {
        return "debit"
    }
}
PaymentInfoCapture.register("debit", DirectDebitCaptureDriver)